module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logId"
  }, [_c('div', [_c('p', [_vm._v("Component with prop "), _c('br'), _vm._v(" selector: '"), _c('strong', [_vm._v(_vm._s(this.selector))]), _vm._v("'")])]), _vm._v(" "), _c('div', {
    staticClass: "logArea"
  }, [_c('ul', {
    staticClass: "noListStyle"
  }, _vm._l((_vm.logs.slice().reverse()), function(log) {
    return _c('li', [_vm._v(_vm._s(log))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8b54c37a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logIdComponent.vue
// module id = 82
// module chunks = 1